import { LoadableChangePass } from "features";
import React from "react";
import { Breadcrumb } from "shared/ui/components";

export default function ChangePassPage() {
  return (
    <>
      <Breadcrumb preCrumb={{ text: "profile", link: "/profile" }} />
      <LoadableChangePass />
    </>
  );
}
